import {useEffect, useRef, useCallback} from 'react';
import Box from '@mui/material/Box';

import { useSessionContext } from '../../../contexts/SessionContext';

import mapboxgl from 'mapbox-gl';
import mapboxGlDraw from "@mapbox/mapbox-gl-draw";
import 'mapbox-gl/dist/mapbox-gl.css';
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'

// @ts-ignore
// eslint-disable-next-line import/no-webpack-loader-syntax, import/no-unresolved
mapboxgl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default;


export default function NamedLocationsMap( props ) {
    //console.debug("RTS Break NamedLocationsMap");

    const {mapBoxKey} = useSessionContext();

    const map = useRef(null);
    const draw = useRef(null);

    // All these functions must be initialized before the first useEffect()
    ///////////////////////////////////////////////////////////
    const setPoints = useCallback((evt) => {
        var latLons = draw.current.getAll().features;

        if (latLons.length > 0) {
            var pts = draw.current.getAll().features[0].geometry.coordinates[0];
            props.setPointsFx(pts);
        }
        else {
            props.setPointsFx([]);
        }
    }, [props]);


    const createDraw = useCallback((evt) => {
        setPoints(evt);
        props.setFormDirtyFx(1);
    }, [setPoints, props]);    


    const deleteDraw = useCallback((evt) => {
        setPoints(evt);
        props.setFormDirtyFx(1);
    }, [setPoints, props]);    


    const updateDraw = useCallback((evt) => {
        setPoints(evt);
        props.setFormDirtyFx(1);
    }, [setPoints, props]);    


    function sortByAttr(array, attr){
        return array.sort(function(a, b) {
            var x = a[attr]; var y = b[attr];
            return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        });
    };


    const drawPolygon = useCallback((points) => {
        const sortedArr = sortByAttr(points, "pointsequence");

        let ptsArr = [];
        for (let c = 0; c < sortedArr.length; c++) {

            ptsArr.push( [ parseFloat(sortedArr[c].lng), parseFloat(sortedArr[c].lat) ] );
        }

        var geoJSON =
            {
            "type": "FeatureCollection",
            "features":
                [
                    {
                        "type": "Feature",
                        "properties": { "class_id": 1 },
                        "geometry":
                        {
                            "type": "Polygon",
                            "coordinates":
                            [
                                ptsArr
                            ]
                        }
                    }
                ]
            };
          draw.current.set(geoJSON);

          setPoints(null);
    }, [setPoints]);
    ///////////////////////////////////////////////////////////

    // Draw the base Map.
    useEffect(() => {
        if(map.current) return;

        map.current = new mapboxgl.Map({
            container: "mapContainer",
            accessToken: mapBoxKey,
            style: "mapbox://styles/mapbox/streets-v11",
            center: [props.centerLng, props.centerLat],
            zoom: 12
        });

        //map.addControl(new mapboxgl.NavigationControl());

        if(props.mode === 1){
            var maxLng = 0, maxLat = 0, minLng = 0, minLat = 0;
            let points = props.data;
            points.forEach(function(item, index){
                if(index === 0){
                    maxLng = item.lng;
                    minLng = item.lng;
                    maxLat = item.lat;
                    minLat = item.lat;
                }
                else{
                    maxLng = item.lng > maxLng ? item.lng : maxLng;
                    minLng = item.lng < minLng ? item.lng : minLng;
                    maxLat = item.lat  > maxLat ? item.lat  : maxLat;
                    minLat = item.lat  < minLat ? item.lat  : minLat;
                }

            });

            var sw = new mapboxgl.LngLat(minLng, minLat);
            var ne = new mapboxgl.LngLat(maxLng, maxLat);
            var llb = new mapboxgl.LngLatBounds(sw, ne);

            map.current.fitBounds(llb,
                {
                    padding: { top: 100, bottom: 100, left: 100, right: 100 } ,
                    animate: false
                }
            );
        }           

    }, [props.mode, props.data, props.centerLat, props.centerLng, mapBoxKey]);


    // Enable the drawing tools on the map.
    useEffect(() => {
        if(!map.current) return;

        if(draw.current) return;

        draw.current = new mapboxGlDraw({
            displayControlsDefault: false,

            // Select which mapbox-gl-draw control buttons to add to the map.
            controls: {
                polygon: true,
                trash: true
            },

            // Set mapbox-gl-draw to draw by default.
            // The user does not have to click the polygon control button first.
            defaultMode: props.mode !== 1 ? 'draw_polygon' : 'simple_select'
        });

        map.current.addControl(draw.current);

        map.current.on('draw.create', createDraw);
        map.current.on('draw.delete', deleteDraw);
        map.current.on('draw.update', updateDraw);        

        map.current.on('draw.modechange', (e) => {

            const data = draw.current.getAll();

            if (draw.current.getMode() === 'draw_polygon') {

                var pids = []

              // ID of the added template empty feature
              const lid = data.features[data.features.length - 1].id

              data.features.forEach((f) => {

                if (f.geometry.type === 'Polygon' && f.id !== lid) {
                  pids.push(f.id)
                }
              })

              draw.current.delete(pids)
            }
        });

        if (props.mode === 1) {
            drawPolygon(props.data);
        }
    }, [props.data, props.mode, props.formDirty, deleteDraw, drawPolygon, updateDraw, createDraw]);


    //Move the map to a center point.
    useEffect(() => {
        if(!map.current) return;
        
        if(props.search === true){
            map.current.flyTo({
            center: [props.centerLng, props.centerLat],
            zoom: 14, // Optional: Set a specific zoom level
            speed: 1.2, // Optional: Control the animation speed
            curve: 1,   // Optional: Control the animation curve
            essential: true // Optional: Ensure animation plays even if prefers-reduced-motion is enabled
            });


            // const elMarker = document.createElement('div');

            //     if(ld.curTrackerESN !== null){
            //         elMarker.className = "rtsTrackerMarker";
            //     }
            //     else{
            //         elMarker.className = "rtsMarker rtsDarkBackground";
            //     }
            //     const elNum = document.createElement('span');
            //     elNum.className = "rtsLightForeground";
            //     elNum.innerHTML = markerCount;
            //     elMarker.appendChild(elNum)


            //     var serNum = ld.reelSerialNumber==null?'':ld.reelSerialNumber;
            //     let markerHTML = '<div><label style="font-size:1.5em; font-Weight:bold;">' + serNum + '</label></div>'
            //     + '<div><label>Product:</label><span>' + ld.curAliasName + '</span></div>'  
            //     + '<div><label style="font-Weight:bold; padding-top:5px;">Location Information</span></div>'
            //     + '<div><label style="padding-left:5px;">Date & Time:</label><span>' + formatDate(ld.curLastLocationDT) + '</span></div>'
            //     + '<div><label style="padding-left:5px;">Latitude:</label><span>' + ld.curLat + '</span></div>'
            //     + '<div><label style="padding-left:5px;">Longitude:</label><span>' + ld.curLng + '</span></div>';
                
            //     if(ld.trackerESN!=null){
            //         markerHTML = markerHTML + '<div style="text-align:center; margin-top:10px;"><span style="font-weight:bold;">' + ld.trackerESN + '</span></div>';
            //     } 

            let coord = [props.centerLng, props.centerLat];

            new mapboxgl.Marker()
                 .setLngLat(coord)
                 .addTo(map.current);            
            
            props.setSearchFx(false);
        }

    }, [props.centerLat, props.centerLng, props]);



    return(
        //<Box id="mapContainer" style={{ width: "550px", minWdith: "400px", maxWidth: "700px", minHeight: "400px", maxHeight: "600px" }}></Box>
        <Box id="mapContainer" sx={{ width:{xs:"350px", sm:"450px", md:"550px", lg:"700px"}, height:{xs:"300px", sm:"350px", md:"400px", lg:"550px"}, border:"1px,solid,black"}}></Box>
    );
}
